import { Component, EventEmitter, HostListener, Output, ViewChild, ElementRef} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subject, filter, map, mergeMap, takeUntil } from 'rxjs';
import { UsersService } from 'src/app/private/services/users.service';
import { AuthService } from 'src/app/public/services/auth.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  @ViewChild('dropdownToggle', { static: false }) dropdownToggle!: ElementRef;
  @ViewChild('mobileDropdown', { static: false }) mobileDropdown!: ElementRef;
  @ViewChild('profileDropdownWrapper', { static: false }) profileDropdownWrapper!: ElementRef
  mobiledropdown: boolean = false;
  isDropdownOpen: boolean = false;
  @Output() toggleMenuEvent = new EventEmitter<void>();  
  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  profileName: any;
  logo: any;
  currentTheme = 'default';
  currentTitle:any
  selectedCenter:any = ""
  centerList:any = [];
  spaciality:any = "";

  userMenu = [ { title: 'Profile' }, { title: 'Log out' } ];

  constructor(private userApi:UsersService, private localStorage:LocalStorageService,private router:Router,private activatedRoute:ActivatedRoute,private auth:AuthService) {
    this.profileName = localStorage.getProfileName();
    this.spaciality = localStorage.getSpecialty();

    this.router.events.pipe(
      filter((ev) => ev instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map((route:any) => {
        let title = route.data['title'] || '';
        while (route.firstChild) {
          route = route.firstChild;
          title+= route.data['title'];
        }
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
      mergeMap((route) => route.data),
    ).subscribe((event:any) => this.currentTitle = event['title']);
  }

  public toggleMenu() {
    this.toggleMenuEvent.emit();
  }

  toggleProfileDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  closeDropdown() {
    this.isDropdownOpen = false;
  }

changeCenter(event:any)
{
 let center_id = event.target.value;
 if(center_id)
 {
  localStorage.setItem('center_id', center_id);
  location.reload();
 }
}
  ngOnInit() {
  
   // this.currentTitle = this.route.data['title'] ;
   this.logo = (this.localStorage.getHospitalLogo()!="null") ? this.localStorage.getHospitalLogo() : "assets/img/img.png"
   let param = {
    where:{
      hospital_id:this.localStorage.getHospitalId(),
    }
   }
   this.userApi.getAllCenter(param).subscribe({
    next:(res)=>{
      if(res && res.length > 0)
      {
        this.centerList = res;
        const currentCenterId = this.localStorage.getCenterId();
        const exists = res.some((item: any) => item.center_id == currentCenterId);
        if (currentCenterId && currentCenterId !== 'null' && currentCenterId !== 'undefined' && exists) {
          this.selectedCenter = currentCenterId;
        } else {
          this.selectedCenter = res[0].center_id;
          localStorage.setItem('center_id', res[0].center_id);
        }
      } else {
        this.centerList = res || [];
        this.selectedCenter = this.localStorage.getCenterId() || "";
      }
    },
    error:(e)=>{}
   })
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
  }

  toggleSidebar(): boolean {
    return false;
  }

  navigateHome() {
    return false;
  }
  logout()
  {
    this.auth.logOut();
    this.router.navigate(['login'])
  }

  toggleDropdown(){
    this.mobiledropdown = !this.mobiledropdown;
  }
  @HostListener('document:click', ['$event'])
handleClickOutside(event: Event) {
  // Handle mobile dropdown
  const toggleEl = this.dropdownToggle?.nativeElement;
  const dropdownEl = this.mobileDropdown?.nativeElement;

  if (
    this.mobiledropdown &&
    toggleEl &&
    dropdownEl &&
    !toggleEl.contains(event.target) &&
    !dropdownEl.contains(event.target)
  ) {
    this.mobiledropdown = false;
  }

  // Handle desktop profile dropdown
  const profileDropdownEl = this.profileDropdownWrapper?.nativeElement;
  if (
    this.isDropdownOpen &&
    profileDropdownEl &&
    !profileDropdownEl.contains(event.target)
  ) {
    this.isDropdownOpen = false;
  }
}

}
